import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart_items: localStorage.getItem("cart_items")
    ? JSON.parse(localStorage.getItem("cart_items"))
    : [],
  product_item: 1,
  cartTotalAmount: 0,
};

const cartUiSlice = createSlice({
  name: "cartUi",
  initialState: initialState,

  reducers: {
    // addToCart: (state, action) => {
    //   console.log(action.payload, "action pay cart items");
    //   const itemInCart = state.cart_items.some(
    //     (item) =>
    //       item?.product?.product_id === action.payload[0].product?.product_id
    //   );

    //   if (itemInCart) {
    //     const item = state.cart_items.find(
    //       (item) =>
    //         item?.product?.product_id === action.payload[0].product?.product_id
    //     );
    //     if (state.product_item) {
    //       item.cartCount = item.cartCount + state.product_item;
    //       return;
    //     }
    //     if (item?.product?.quantity_label === item.cartCount) {
    //       return;
    //     }
    //     item.cartCount++;
    //   } else {
    //     state.cart_items.push({
    //       ...action.payload[0],
    //       cartCount: state.product_item,
    //     });
    //   }

    //   localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
    // },
addToCart: (state, action) => {
  console.log(action.payload, "action pay cart items");

  const incomingProduct = action.payload[0]?.product;
  const incomingAttributes = incomingProduct?.attributes || [];

  const item = state.cart_items.find((item) => {
    const existingProduct = item?.product;
    const existingAttributes = existingProduct?.attributes || [];

    const sameProductId = existingProduct?.product_id === incomingProduct?.product_id;

    const sameAttributes =
      existingAttributes.length === incomingAttributes.length &&
      existingAttributes.every((attr, index) => (
        attr.attribute_name === incomingAttributes[index]?.attribute_name &&
        attr.attribute_value === incomingAttributes[index]?.attribute_value
      ));

    return sameProductId && sameAttributes;
  });

  if (item) {
    // Increase cart count for same product with same attributes
    if (state.product_item) {
      item.cartCount += state.product_item;
    } else if (item?.product?.quantity_label !== item.cartCount) {
      item.cartCount++;
    }
  } else {
    // Push new item for different product or different attributes
    state.cart_items.push({
      ...action.payload[0],
      cartCount: state.product_item || 1,
    });
  }

  localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
}
,
    // increaseCart: (state, action) => {
    //   const item = state.cart_items.find(
    //     (item) =>
    //       item?.product?.product_id === action.payload.product?.product_id
    //   );
    //   if (item?.product?.quantity_label === item.cartCount) {
    //     return;
    //   }
 
    //   item.cartCount++;
    //   localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
    // },
increaseCart: (state, action) => {
  const incomingProduct = action.payload.product;
  const incomingAttributes = incomingProduct?.attributes || [];

  const item = state.cart_items.find((item) => {
    const existingProduct = item?.product;
    const existingAttributes = existingProduct?.attributes || [];

    const sameProductId = existingProduct?.product_id === incomingProduct?.product_id;

    const sameAttributes =
      existingAttributes.length === incomingAttributes.length &&
      existingAttributes.every((attr, index) =>
        attr.attribute_name === incomingAttributes[index]?.attribute_name &&
        attr.attribute_value === incomingAttributes[index]?.attribute_value
      );

    return sameProductId && sameAttributes;
  });

  if (item) {
    if (item?.product?.quantity_label === item.cartCount) {
      return;
    }
    item.cartCount++;
    localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
  }
},

    // decreaseCart: (state, action) => {
    //   const item = state.cart_items.find(
    //     (item) =>
    //       item?.product?.product_id === action.payload.product?.product_id
    //   );

    //   if (item.cartCount > 1) {
    //     item.cartCount--;
    //   } else if (item.cartCount === 1) {
    //     const removeCart = state.cart_items.filter(
    //       (item) =>
    //         item?.product?.product_id !== action.payload.product?.product_id
    //     );
    //     state.cart_items = removeCart;
    //     localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
    //   }
    // },
decreaseCart: (state, action) => {
  const incomingProduct = action.payload.product;
  const incomingAttributes = incomingProduct?.attributes || [];

  const itemIndex = state.cart_items.findIndex((item) => {
    const existingProduct = item?.product;
    const existingAttributes = existingProduct?.attributes || [];

    const sameProductId = existingProduct?.product_id === incomingProduct?.product_id;

    const sameAttributes =
      existingAttributes.length === incomingAttributes.length &&
      existingAttributes.every((attr, index) =>
        attr.attribute_name === incomingAttributes[index]?.attribute_name &&
        attr.attribute_value === incomingAttributes[index]?.attribute_value
      );

    return sameProductId && sameAttributes;
  });

  if (itemIndex !== -1) {
    const item = state.cart_items[itemIndex];

    if (item.cartCount > 1) {
      item.cartCount--;
    } else {
      // Remove the item if count is 1
      state.cart_items.splice(itemIndex, 1);
    }

    localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
  }
},

    increaseProduct: (state, action) => {
      state.product_item++;
    },

    // removeProductFromCart: (state, action) => {
  
    //   const removeCart = state.cart_items.filter(
    //     (item) =>
    //       item?.product?.product_id !== action.payload.product?.product_id
    //   );
    //   state.cart_items = removeCart;
    //   localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
    // },
removeProductFromCart: (state, action) => {
  const incomingProduct = action.payload.product;
  const incomingAttributes = incomingProduct?.attributes || [];

  const removeCart = state.cart_items.filter((item) => {
    const existingProduct = item?.product;
    const existingAttributes = existingProduct?.attributes || [];

    const sameProductId = existingProduct?.product_id === incomingProduct?.product_id;

    const sameAttributes =
      existingAttributes.length === incomingAttributes.length &&
      existingAttributes.every((attr, index) =>
        attr.attribute_name === incomingAttributes[index]?.attribute_name &&
        attr.attribute_value === incomingAttributes[index]?.attribute_value
      );

    // Keep item if it's NOT a match (i.e., do NOT remove it)
    return !(sameProductId && sameAttributes);
  });

  state.cart_items = removeCart;
  localStorage.setItem("cart_items", JSON.stringify(state.cart_items));
},

    decreaseProduct: (state, action) => {
      if (state.product_item >= 1) {
        state.product_item--;
      }
    },
    resetProduct: (state, action) => {
      state.product_item = 1;
    },

    calculateCartTotal: (state, action) => {
      const cartTotal = state?.cart_items.reduce((cartTotal, cart_items) => {
        const { product, cartCount } = cart_items;
        console.log(product, "product");
        // const itemTotal = product.discount_price
        //   ? product.discount_price * cartCount
        //   : product.unit_price * cartCount;
const itemTotal = product?.attributes?.[0]?.price
  ? product?.attributes[0].price * cartCount
  : product?.discount_price
    ? product?.discount_price * cartCount
    : product?.unit_price * cartCount;

        return cartTotal + itemTotal;
      }, 0);
      state.cartTotalAmount = cartTotal;
      if (cartTotal !== 0) {
        localStorage.setItem("cartTotal", cartTotal);
      } else {
        localStorage.removeItem("cartTotal");
      }
      //  state.cartTotalCount = quantity
    },
  },
});

export const {
  addToCart,
  increaseCart,
  decreaseCart,
  removeCart,
  increaseProduct,
  decreaseProduct,
  resetProduct,
  calculateCartTotal,
  removeProductFromCart,
} = cartUiSlice.actions;
export default cartUiSlice.reducer;
